module.exports = __webpack_public_path__ + "img/invite_info.e4b2ca36.png";